import React from 'react'
import {Icon} from '@chakra-ui/react'

const FaqIconAlternative = (props) => {
    return (
        <Icon viewBox="0 0 48 48" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24ZM46.08 24C46.08 36.1945 36.1945 46.08 24 46.08C11.8056 46.08 1.92 36.1945 1.92 24C1.92 11.8056 11.8056 1.92 24 1.92C36.1945 1.92 46.08 11.8056 46.08 24Z"
                fill="currentColor"
            />
            <path
                d="M17.28 17.8709C17.28 18.4011 16.8502 18.8309 16.32 18.8309C15.7898 18.8309 15.36 18.4011 15.36 17.8709C15.36 12.775 19.4395 8.64016 24.48 8.64016C29.5205 8.64016 33.6 12.775 33.6 17.8709C33.6 20.7615 32.428 22.5282 29.5316 25.1301C29.3824 25.2641 28.8449 25.7434 28.7346 25.8423C25.6608 28.5983 24.5074 30.4152 24.5074 33.6248V34.8851C24.5074 35.4153 24.0776 35.8451 23.5474 35.8451C23.0172 35.8451 22.5874 35.4153 22.5874 34.8851V33.6248C22.5874 29.7419 24.0119 27.498 27.4528 24.4128C27.566 24.3113 28.1026 23.8329 28.2485 23.7017C30.7745 21.4327 31.68 20.0676 31.68 17.8709C31.68 13.8296 28.4543 10.5602 24.48 10.5602C20.5057 10.5602 17.28 13.8296 17.28 17.8709Z"
                fill="currentColor"
            />
            <path
                d="M23.52 37.8632C24.3184 37.8632 24.96 38.5135 24.96 39.3103C24.96 40.107 24.3184 40.7574 23.52 40.7574C22.7216 40.7574 22.08 40.107 22.08 39.3103C22.08 38.5135 22.7216 37.8632 23.52 37.8632Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default FaqIconAlternative
